<template>
  <component :is="currentComponent"></component>
</template>

<script>
import HormoneReplacementContentEn from './HormoneReplacementContent/HormoneReplacementContentEn.vue';
import HormoneReplacementContentPtBR from './HormoneReplacementContent/HormoneReplacementContentPtBR.vue';
import { LANGUAGES } from '@/common/constants';

export default {
  props: {
    language: {
      type: String,
      default: LANGUAGES.EN
    }
  },
  computed: {
    currentComponent() {
      return this.language === LANGUAGES.PT_BR ? HormoneReplacementContentPtBR : HormoneReplacementContentEn;
    }
  }
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
